import { render } from "./ErrorModalView.vue?vue&type=template&id=35a741d2"
import script from "./ErrorModalView.vue?vue&type=script&lang=js"
export * from "./ErrorModalView.vue?vue&type=script&lang=js"

import "./ErrorModalView.vue?vue&type=style&index=0&id=35a741d2&lang=css"

import exportComponent from "/home/runner/work/lumaa.fr/lumaa.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__